import { render, staticRenderFns } from "./DeclareInfo.vue?vue&type=template&id=1da1c570&scoped=true"
import script from "./DeclareInfo.vue?vue&type=script&lang=js"
export * from "./DeclareInfo.vue?vue&type=script&lang=js"
import style0 from "./DeclareInfo.vue?vue&type=style&index=0&id=1da1c570&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da1c570",
  null
  
)

export default component.exports